<ellf-error-page (back)="back()" [type]="type" [desc]="desc" [title]="title">
</ellf-error-page>
